import React, { useState } from 'react';
import PropTypes from 'prop-types';

import {
  Card,
  CardContent,
  Divider
} from '@mui/material';

import TabContext from '@mui/lab/TabContext';

import { withRouter } from 'react-router-dom';

import UploadDoc from '../../../Ptdoc/components/Modal_UploadDoc';

import MessageModal from '../Modal/Modal-Message';

import SoapTabs from './SoapTabs';
import SoapTabPanel from './SoapTabPanel';
import MedicalHxTabPanel from './MedicalHxTabPanel';
import DiagnosisTabPanel from './DiagnosisTabPanel';
import DocumentsTabPanel from './DocumentsTabPanel';

import {
  cardContentSx,
  soapLeftCardSx
} from './SoapLeftStyles';

const SoapLeft = ({
  className,
  ...rest
}) => {
  const [isPast, setIsPast] = useState(false);

  const [openUpload, setOpenUpload] = useState(false);

  const [openMessage, setOpenMessage] = useState(false);

  const [value, setValue] = useState('1');

  const [encounters, setEncounters] = useState([]);

  const setPast = () => {
    setIsPast(previous => !previous);
  };

  const handleChange = (
    event,
    newValue
  ) => {
    setValue(newValue);
  };

  const handleSaveEncounter = encounter => {
    setEncounters(previous => {
      const existingIndex =
        previous.findIndex(
          item => item.id === encounter.id
        );

      if (existingIndex >= 0) {
        return previous.map(item =>
          item.id === encounter.id
            ? {
                ...item,
                ...encounter,
                status: 'draft',
                signedBy: ''
              }
            : item
        );
      }

      return [
        {
          ...encounter,
          status: 'draft'
        },
        ...previous
      ];
    });
  };

  const handleSignEncounter = encounter => {
    setEncounters(previous => {
      const existing = previous.some(
        item => item.id === encounter.id
      );

      if (existing) {
        return previous.map(item =>
          item.id === encounter.id
            ? {
                ...item,
                ...encounter,
                status: 'signed',
                signedBy: 'Dr. Charles'
              }
            : item
        );
      }

      return [
        {
          ...encounter,
          status: 'signed',
          signedBy: 'Dr. Charles'
        },
        ...previous
      ];
    });
  };

  const handleMessageOpen = () => {
    setOpenMessage(true);
  };

  const handleMessageClose = () => {
    setOpenMessage(false);
  };

  const handleUploadOpen = () => {
    setOpenUpload(true);
  };

  const handleUploadClose = () => {
    setOpenUpload(false);
  };

  const handleMessageSend = () => {
    // TODO: API call

    setOpenMessage(false);
  };

  return (
    <Card
      {...rest}
      className={className}
      sx={soapLeftCardSx}>
      <TabContext value={value}>
        <SoapTabs
          onChange={handleChange}
        />

        <Divider />

        <CardContent sx={cardContentSx}>
          <SoapTabPanel
            isPast={isPast}
            setPast={setPast}
            encounters={encounters}
            onSaveEncounter={
              handleSaveEncounter
            }
            onSignEncounter={
              handleSignEncounter
            }
          />

          <MedicalHxTabPanel />

          <DiagnosisTabPanel />

          <DocumentsTabPanel
            onMessage={handleMessageOpen}
            onUpload={handleUploadOpen}
          />
        </CardContent>
      </TabContext>

      <UploadDoc
        open={openUpload}
        onClose={handleUploadClose}
      />

      <MessageModal
        open={openMessage}
        onClose={handleMessageClose}
        onSend={handleMessageSend}
      />
    </Card>
  );
};

SoapLeft.propTypes = {
  className: PropTypes.string
};

export default withRouter(SoapLeft);